module.exports = __webpack_public_path__ + "img/mobile scanner stand11.625bfc30.jpg";